// extracted by mini-css-extract-plugin
module.exports = {"hotelFacility":"HotelFacility_hotelFacility__aJrJ5","facilityTooltip":"HotelFacility_facilityTooltip__32J4S"};